import React from 'react';

function Header({ resumeData }) {
  if (!resumeData) {
    return null;
  }

  return (
    <header id="home">
      <nav id="nav-wrap">
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
        <a className="mobile-btn" href="#hide-nav" title="Hide navigation">Hide navigation</a>
        <ul id="nav" className="nav">
          <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
          <li><a className="smoothscroll" href="#about">About</a></li>
          <li><a className="smoothscroll" href="#resume">Resume</a></li>
          <li><a className="smoothscroll" href="#portfolio">Works</a></li>
          <li><a className="smoothscroll" href="#testimonials">Testimonials</a></li>
        </ul>
      </nav>
      <div className="row banner">
        <div className="banner-text">
          <h1 className="responsive-headline">I'm {resumeData.name}.</h1>
          <h3>I'm a {resumeData.role}. {resumeData.roleDescription}</h3>
          <hr />
          <ul className="social">
            <li>
              <a href="https://www.linkedin.com/in/kevinyc/" target="_blank" rel="noopener noreferrer">
                <i className="fa fa-linkedin" />
              </a>
            </li>
            <li>
              <a href="https://github.com/kevinyc-dri" target="_blank" rel="noopener noreferrer">
                <i className="fa fa-github" />
              </a>
            </li>
            {resumeData.foldAppLink && (
              <li>
                <a href={resumeData.foldAppLink} target="_blank" rel="noopener noreferrer">
                  <img 
                    src="https://uploads-ssl.webflow.com/5e5d98432c687cb6c71f7894/5fa44b8b3b1bf8774fad57dd_rotating_fold_bitcoin_trans.gif" 
                    width="85" 
                    alt="freebitcoin" 
                    className="image-23"
                  />
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
      <p className="scrolldown">
        <a className="smoothscroll" href="#about"><i className="icon-down-circle" /></a>
      </p>
    </header>
  );
}

export default Header;